import {
  TrackingStatus,
  TrackingStatusDescription,
} from "../tracking-history/web";
import { LastStatusBlockProps } from "./types";
import { TrackingStatus as TrackingStatusEnum } from "@babackapp/tracking-status-registry";

export function LastStatusWeb(props: LastStatusBlockProps) {
  const { parcel, locale } = props;

  // const alignment = block.alignment; // Removed unused variable
  if (
    !parcel ||
    !parcel.events ||
    !Array.isArray(parcel.events) ||
    parcel.events.length === 0
  ) {
    return null;
  }

  const lastEvent = [...parcel.events].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
  )[0];

  if (!lastEvent) {
    return null;
  }

  return (
    <div className="text-center flex flex-col">
      <span className="font-bold text-xl">
        <TrackingStatus status={lastEvent.status as TrackingStatusEnum} locale={locale} />
      </span>
      <p className="text-sm text-muted-foreground">
        <TrackingStatusDescription
          status={lastEvent.status as TrackingStatusEnum}
          locale={locale}
        />
      </p>
    </div>
  );
}
